import type { AssetListItem } from '@fleet-bffs/api-contract';
import type ErrorRecord from '~/data/ErrorRecord';

export type AssetMapAndDetailsState = {
  isLoading: boolean;
  isPartial?: boolean;
  isOutdated?: boolean;
  asset?: AssetListItem;
  error?: ErrorRecord;
};

export const initialAssetMapAndDetailsState: AssetMapAndDetailsState = {
  isLoading: false,
  asset: undefined,
  error: undefined,
};
